import React from 'react';

const DashboardMeterSVG = ({ width, height, radius, strokeWidth, fontSize, progress}) => {
  const circumference = 2 * Math.PI * radius;
  let offset = circumference * ((100 - progress)/100);

  if (isNaN(progress)) {
    progress = 0;
    offset = 360;
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      {/* Background Circle with Radial Gradient */}
      <circle cx={width/2} cy={height/2} r={radius} fill="url(#backgroundGradient)" />
      {/* Progress Indicator with Linear Gradient */}
      <circle
        cx={width/2}
        cy={height/2}
        r={radius}
        fill="transparent"
        stroke="url(#progressGradient)"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
      {/* Text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        alignmentBaseline="middle"
        fontSize={fontSize}
        fill="#3498db"
      >
        {Math.round(progress)}%
      </text>
      {/* Gradients */}
      <defs>
        <radialGradient
          id="backgroundGradient"
          cx="50%"
          cy="50%"
          r="50%"
          fx="50%"
          fy="50%"
        >
          <stop offset="0%" style={{ stopColor: "#e0e0e0", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#f7f7f7", stopOpacity: 1 }} />
        </radialGradient>
        <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#3498db", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#2980b9", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DashboardMeterSVG;
